import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Newsletter from "../Components/Newsletter";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { useSelector } from "react-redux";
import PricingTableSecond from "../Components/PricingTableSecond";
import WebBuilderHero from "./WebBuilderHero";
import { CgEnter } from "react-icons/cg";
import { FaDisplay } from "react-icons/fa6";
import {
  BsSpeedometer,
  BsFileEarmarkArrowUp,
  BsFilePerson,
  BsHeartPulse,
  BsCheck2Circle,
  BsChatRightText,
  BsCalendar4Week,
  BsArchive,
  BsChevronDown,
} from "react-icons/bs";
import "./WebBuilderFAQs.css";
import { IoImagesOutline, IoChatbubblesOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { FaChalkboardTeacher, FaUserLock, FaShieldAlt, FaPalette, FaDoorOpen } from "react-icons/fa";
import { RiNumber1 } from "react-icons/ri";
import { BsGraphUp, BsFileText, BsGift } from "react-icons/bs";
import PricingPlans from "./PricingPlans";
import WebBuilderPricingSection from "./WebBuilderPricingSection";
function WebBuilder() {
  const branding = useSelector((state) => state.branding.value);
  useEffect(() => {
    console.log("branding", branding);
  }, [branding]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const showProviderSummary = false; // Icon + title only (grid layout finalized)

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  // First three FAQs from Web-Builder section on FAQs page (faqs.json)
  const webBuilderFaqData = [
    {
      question: "What is Web Builder?",
      answer:
        "Web-Builder is a platform designed for healthcare facilities to create and manage professional, responsive websites without requiring extensive technical knowledge.",
    },
    {
      question: "Do I need coding knowledge to use Web Builder?",
      answer:
        "No, Web Builder is designed to be user-friendly with drag-and-drop functionality and intuitive interfaces. You can create and manage your website without any coding experience.",
    },
    {
      question: "Can I customize my website design with Web Builder?",
      answer:
        "Yes, Web Builder offers a wide range of pre-designed layouts and customization options. You can personalize colors, layouts, content, and features to match your healthcare facility's brand and needs.",
    },
  ];

  /* Commented out: existing faqData (replaced by webBuilderFaqData above)
  const faqData = [
    {
      question: "What is a web builder, and why do I need one?",
      answer:
        "A web builder is a tool that allows you to create websites without needing to code. You need one to easily design and publish a professional-looking website for your business or personal use",
    },
    {
      question: "Do I need any technical skills to use ClinTa Web-Builder?",
      answer:
        "No, ClinTa Web-Builder  is designed for users of all skill levels. It features a user-friendly interface that allows you to create and customize your website without any coding knowledge.",
    },
    {
      question: "Can I customize the design of my website?",
      answer:
        "Absolutely! ClinTa Web-Builder offers a wide range of customizable templates, colors, fonts, and layouts, allowing you to create a unique website that reflects your brand identity.",
    },
    {
      question: "Is the website mobile-friendly?",
      answer:
        "Yes, all websites created with ClinTa Web-Builder are automatically optimized for mobile devices, ensuring a seamless user experience across smartphones, tablets, and desktops.",
    },
    {
      question: "Can I integrate third-party tools to my site?",
      answer:
        "Yes, ClinTa Web-Builder supports integration with various third-party tools and widgets, such as social media buttons, to enhance your website's functionality.",
    },
    {
      question: "Is there customer support for issues?",
      answer:
        "Of course! We offer dedicated customer support to assist you with any questions or technical issues you may encounter while using ClinTa Web-Builder. Simply reach out to our support team for assistance.",
    },
    {
      question: "How can I publish my website once it's ready?",
      answer:
        "Publishing your website is as simple as clicking a button. ClinTa Web-Builder provides easy-to-follow instructions for publishing your website to your domain or hosting platform.",
    },
    {
      question: "Is there a limit on adding website banners?",
      answer:
        "No, there is no limit to the number of banners you can create on your website with ClinTa Web-Builder. You can add as many banners as you need to showcase your content and services.",
    },
    {
      question: "Can I track the performance of my website with analytics?",
      answer:
        "Yes, ClinTa Web-Builder allows you to integrate with popular analytics tools like Google Analytics to track your website's performance, including traffic, user behavior, and conversions.",
    },
    {
      question: "Is my website's data secure?",
      answer:
        "Yes, we take security seriously. Your website's data is encrypted and stored securely on our servers, and we regularly update our security measures to protect against cyber threats and data breaches.",
    },
    {
      question: "What happens if I decide to cancel my subscription?",
      answer:
        "If you choose to cancel your subscription, you can copy your website's content and data to ensure future use. Additionally, you can always re-subscribe to access your website and continue editing it.",
    },
    {
      question:
        "How Web-Builder (For Doctors) benefits clinical practice?",
      answer:
        "The ClinTa Web-Builder  (Doctor version) is tailored to meet the specific needs of medical professionals, allowing you to create a professional website that showcases your expertise, services, and patient care philosophy.",
    },
    {
      question: "Can I include patient education materials on my website?",
      answer:
        "Yes, you can easily integrate patient education materials into your website using  ClinTa Web-Builder intuitive tools and features.",
    },

    {
      question: "Is there a feature to schedule appointments online?",
      answer:
        "Absolutely! Our Web-Builder  offers an appointment scheduling feature that allows patients to book appointments online, helping you streamline your practice's scheduling process.",
    },
    {
      question: "Can I showcase patient testimonials on my website?",
      answer:
        "Yes, you can display patient testimonials and reviews on your website to build trust and credibility with prospective patients. Our Web-Builder provides easy-to-use tools for adding testimonials to your site.",
    },
    {
      question: "How its hospital version enhances our online presence?",
      answer:
        "The ClinTa Web-Builder  (Hospitals version)  empowers your institution to create a dynamic online presence that highlights your facilities, medical specialties, and commitment to patient care, helping you stand out in the competitive healthcare landscape.",
    },
    {
      question: "Is patient portal secure for EMRs and appointments?",
      answer:
        "Yes, ClinTa Web-Builder  (Hospital version) offers a secure patient portal feature that allows patients to access their medical records, schedule appointments, and communicate with healthcare providers online, enhancing patient engagement and satisfaction.",
    },
    {
      question: "Can I show accreditations and awards on website?",
      answer:
        "Yes, you can prominently display your hospital's accreditations, certifications, and quality awards on your website to showcase your commitment to excellence in healthcare delivery and patient safety.",
    },
    {
      question: "How its Pathology version benefits lab's online presence?",
      answer:
        "Our ClinTa Web-Builder (Pathology version) is designed to help your lab establish a professional online presence, allowing you to showcase your diagnostic services, advanced technology, and commitment to precision to attract more clients and patients.",
    },
    {
      question: "Can I mention the lab's test and service range?",
      answer:
        "Yes, you can provide detailed information about the various tests and services offered by your pathology laboratory, including descriptions, test panels, specimen requirements, and turnaround times, to help potential clients and patients understand your capabilities.",
    },
    {
      question: "Is its Pathology version secure to deliver test results?",
      answer:
        "Yes, ClinTa Web-Builder  (Pathology version) offers a secure online test results delivery feature that allows patients to access their test results securely and conveniently through a patient portal, ensuring patient privacy and confidentiality. It can be done if you are using ClinTa LARIS.",
    },
    {
      question: "Can we integrate with EMR systems for data exchange?",
      answer:
        "Yes, ClinTa Web-Builder conditionally offers integration options with electronic medical record (EMR) systems, allowing for seamless data exchange and interoperability with healthcare providers' systems, streamlining workflows and improving efficiency.",
    },

    {
      question: "How is it specialized for healthcare professionals?",
      answer:
        "ClinTa Web-Builder is specifically designed to meet the unique needs and requirements of healthcare professionals. We understand the importance of compliance, security, and patient confidentiality in the healthcare industry, and our platform is tailored to address these concerns.",
    },
    {
      question: "What special does it offer to healthcare professionals?",
      answer:
        "ClinTa Web-Builder offers a range of specialized, secure patient portals for online communication and appointment scheduling, integration with electronic health records (EHR) systems, and customizable templates designed specifically for healthcare practices.",
    },
    {
      question: "How does it ensure compliance with institutions like IHRA?",
      answer:
        "We take compliance seriously and have implemented strict security measures to ensure that our platform meets IHRA & PHC and all other regulatory authorities’ requirements. Our infrastructure is built to provide end-to-end encryption, access controls, and regular security audits to protect sensitive patient information.",
    },

    {
      question: "Does it provide healthcare practices' branding?",
      answer:
        "Yes, absolutely! Our web builder offers customizable templates and design options that allow healthcare practices to showcase their unique brand identity and services. Whether you're a small clinic or a large hospital, our platform can be tailored to suit your specific needs and preferences.",
    },

    {
      question:
        "How Web-Builder supports online patient interaction?",
      answer:
        "ClinTa Web-Builder includes features such as secure patient portals, online appointment scheduling, telemedicine capabilities, and patient education resources to enhance communication and engagement between healthcare providers and patients. This helps improve patient satisfaction and outcomes.",
    },

    {
      question: "What distinguishes your healthcare-focused web builder?",
      answer:
        "Unlike general business web builders, our platform is built from the ground up with the healthcare industry in mind. We understand the unique challenges and requirements of healthcare providers, and our platform offers specialized features and compliance measures specifically tailored to address these needs.",
    },
  ];
  */

  var BreadCrumbTitle = "Web Builder :: D-Right Technologies";
  document.title = BreadCrumbTitle;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [expandedIndex, setExpandedIndex] = useState(null);
  // const toggleExpandReview = (index) => {
  //   setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  // };

  const handleClick = (index, event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    console.log("handleClick called with index:", index); // Debugging
    toggleExpandReview(index);
  };

  const toggleExpandReview = (index) => {
    console.log("toggleExpandReview called with index:", index); // Debugging
    setExpandedIndex((prevIndex) => {
      console.log("Previous index:", prevIndex); // Debugging
      return prevIndex === index ? null : index;
    });
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  };

  const promosData = [
    {
      // icon: "/assets/img/icon/icon-1.svg",
      icon: "/assets/img/admin-panel-img.png",
      title: "Admin Panel",
      content:
        "It offers an Advanced Admin Panel that goes beyond basic website customization, which enables to effortlessly manage images, colors, text, and banners to maintain a vibrant and dynamic online presence. It additionally offers a Data Management System, allowing you to efficiently handle all records and communication related to patients, doctors, and job applicants.  ",
    },

    {
      // icon: "/assets/img/icon/icon-1.svg",
      icon: "/assets/img/economical-img.png",
      title: "Economical",
      content:
        "It offers a vast array of features at a fraction of the cost of custom-built website. By serving a large number of clients, we achieve economies of scale that individual developers cannot match. Custom development requires extensive time and expertise, making it prohibitively expensive. Hence, cost effectiveness of our product is unparalleled.",
    },

    {
      icon: "/assets/img/scalability-img.png",
      title: "Scalable",
      content:
        "It offers scalability to accommodate your preference for what to show and what not to show to the visitors of your website, it allows you to easily expand your website’s functionality, and add new features, which make it a versatile platform for building dynamic, engaging and a comprehensive website.",
    },

    {
      // icon: "/assets/img/icon/icon-1.svg",
      icon: "/assets/img/user-freinedly-img.png",
      title: "User-Friendly",
      content:
        "It offers user friendly interface that allows individuals to create and customize a website without any coding knowledge or technical skills. Intuitive drag and drop tools, pre-designed templates, and simple editing options make the website-building process easy for everyone. Its data management system is also very easy to understand and operate.",
    },
    {
      icon: "/assets/img/customizable-img.png",
      title: "Customizable",
      content:
        "The ability to personalize the website’s design, layout, and content according to individual preferences is a key feature. Customization options, including diverse templates, multiple banners, color schemes, images, fonts, and multimedia integration, allow users to create an appealing website. Its customization advantages are unique and cost effective.",
    },
    {
      icon: "/assets/img/responsive-img.png",
      title: "Responsive",
      content:
        "Ensuring website looks and functions seamlessly across various devices, including desktops, laptops, tablets, and smartphones, is crucial. A responsive design feature automatically adjusts the layout and content of the website to provide an optimal viewing experience on different screen sizes and resolutions.",
    },
    {
      icon: "/assets/img/intigrated-img.png",
      title: "Integrated",
      content:
        "It integrates with the entire ClinTa range of software programs offering patient access to electronic medical records (EMRs) and all other pathology lab reports on the password protected patient portal given on the website built through web builder. It also integrates appointment panel with hospital software for integrated invoicing.",
    },
    {
      icon: "/assets/img/interactive-img.png",
      title: "Interactive",
      content:
        "It offers interactive features such a secure messaging, appointment, general public feedback, job posting, CV management & interview scheduling. It also offers tele-consultation through e-health module. It also empowers patients with a dedicated portal for accessing integrated relevant data, including test results, medical records, and appointment scheduling.",
    },
    {
      icon: "/assets/img/infromative-img.png",
      title: "Informative",
      content:
        "It provides healthcare information for the community, accessible through the patient portal. It offers valuable resources such as diet facts, healthcare calculators, and home remedies to promote health literacy and wellness education among general public. Comparative nutrient analysis is a unique feature introduced to promote healthy dietary habits.",
    },

    {
      icon: "/assets/img/ssl-certificate-img.png",
      title: "SSL Certified",
      content:
        "It inspires trust and confidence among users by displaying the SSL certificate, indicating a secure connection and protecting against potential cyber threats: ensuring data integrity and confidentiality. Moreover, it can boost our website search engine ranking. We are committed to provide secure website to all our clients.",
    },
    {
      icon: "/assets/img/data-encrpted-img.png",
      title: "Encrypted",
      content:
        "We are fully aware of the sensitivity of privacy of healthcare data of patients  visiting a hospital, hence we utilize advanced encryption algorithms to transform information into unreadable ciphertext, protecting it from unauthorized access. It Provides a secure environment for storing and managing sensitive data.",
    },
  ];

  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeFeatureTab, setActiveFeatureTab] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const logoScrollRef = useRef(null);
  const [isScrollingPaused, setIsScrollingPaused] = useState(false);
  const featureIconStyle = 'arrow'; // Fixed to arrow layout

  // Fixed scroll options - no longer configurable
  const scrollOptions = {
    speed: 'slow',
    animation: 'linear',
    hover: 'pause-logo',
    visual: 'scale',
    direction: 'left-right',
  };
  const [scrollDirection, setScrollDirection] = useState(1);
  const [isMobileTouch, setIsMobileTouch] = useState(false);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  // Detect mobile/touch for click-to-pause instead of hover
  useEffect(() => {
    const checkMobile = () => {
      const touchOrNarrow = window.matchMedia('(pointer: coarse)').matches ||
        window.matchMedia('(max-width: 991px)').matches;
      setIsMobileTouch(touchOrNarrow);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle manual scrolling on mobile - pause auto-scroll when user scrolls
  useEffect(() => {
    const scrollContainer = logoScrollRef.current;
    if (!scrollContainer || !isMobileTouch) return;

    let scrollTimeout;
    let lastScrollLeft = scrollContainer.scrollLeft;

    const handleTouchStart = () => {
      setIsUserScrolling(true);
    };

    const handleScroll = () => {
      // Throttle scroll detection to avoid interfering with smooth auto-scroll
      const currentScrollLeft = scrollContainer.scrollLeft;
      const scrollDelta = Math.abs(currentScrollLeft - lastScrollLeft);
      
      // Only pause if user is actively dragging (large delta)
      if (scrollDelta > 10) {
        setIsUserScrolling(true);
        setIsScrollingPaused(true);
        clearTimeout(scrollTimeout);
        
        // Resume auto-scroll after user stops scrolling for 1.5 seconds
        scrollTimeout = setTimeout(() => {
          setIsUserScrolling(false);
          setIsScrollingPaused(false);
        }, 1500);
      }
      
      lastScrollLeft = currentScrollLeft;
    };

    const handleTouchEnd = () => {
      // Resume auto-scroll after a short delay, but let momentum scrolling finish
      setTimeout(() => {
        setIsUserScrolling(false);
        setIsScrollingPaused(false);
      }, 800);
    };

    scrollContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
    scrollContainer.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      scrollContainer.removeEventListener('touchstart', handleTouchStart);
      scrollContainer.removeEventListener('scroll', handleScroll);
      scrollContainer.removeEventListener('touchend', handleTouchEnd);
      clearTimeout(scrollTimeout);
    };
  }, [isMobileTouch]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Auto-scroll for client logos with options
  useEffect(() => {
    const scrollContainer = logoScrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    let baseScrollSpeed = 0.5;
    
    // Set speed based on option - optimized speeds
    const isMobile = window.matchMedia('(pointer: coarse)').matches || 
                     window.matchMedia('(max-width: 991px)').matches;
    
    // Reduced speeds for smoother, more comfortable scrolling
    switch(scrollOptions.speed) {
      case 'slow': baseScrollSpeed = isMobile ? 0.4 : 0.35; break;
      case 'medium': baseScrollSpeed = isMobile ? 0.8 : 0.7; break;
      case 'fast': baseScrollSpeed = isMobile ? 2.0 : 1.8; break;
      case 'variable': baseScrollSpeed = isMobile ? 0.4 : 0.35; break;
      default: baseScrollSpeed = isMobile ? 0.8 : 0.7;
    }

    let animationFrameId;
    let isInitialized = false;
    let lastTimestamp = 0;
    let variableSpeedAccumulator = 0;
    let loopProgress = 0; // For easing animation
    let bounceOffset = 0; // For bounce animation
    let isBouncing = false;
    let bounceStartTime = 0;

    // Easing function
    const easeInOut = (t) => {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };
    
    // Bounce easing function
    const easeOutBounce = (t) => {
      if (t < 1 / 2.75) {
        return 7.5625 * t * t;
      } else if (t < 2 / 2.75) {
        return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
      } else if (t < 2.5 / 2.75) {
        return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
      } else {
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      }
    };

    const scroll = (timestamp) => {
      if (scrollContainer) {
        // Initialize scroll position from current scrollLeft on first run
        if (!isInitialized) {
          scrollPosition = scrollContainer.scrollLeft;
          lastTimestamp = timestamp;
          isInitialized = true;
        }

        const shouldPause = isUserScrolling ? true : // Always pause when user is manually scrolling
                          scrollOptions.hover === 'pause-logo' ? isScrollingPaused :
                          scrollOptions.hover === 'pause-container' ? isScrollingPaused :
                          scrollOptions.hover === 'no-pause' ? false : isScrollingPaused;

        if (!shouldPause) {
          // Frame-rate independent scrolling for consistent speed
          // Better deltaTime handling for mobile smoothness
          const rawDeltaTime = timestamp - lastTimestamp;
          const deltaTime = Math.max(Math.min(rawDeltaTime, 100), 0) || 16.67; // Clamp between 0-100ms for stability
          let currentSpeed = baseScrollSpeed;

          // Variable speed (accelerating)
          if (scrollOptions.speed === 'variable') {
            variableSpeedAccumulator += 0.001;
            currentSpeed = Math.min(0.3 + variableSpeedAccumulator, 2.0);
          }

          const totalWidth = scrollContainer.scrollWidth;
          const halfWidth = totalWidth / 2;
          const maxWidth = totalWidth - scrollContainer.clientWidth;
          
          // Calculate loop progress for easing (before applying speed)
          if (scrollOptions.animation === 'easing') {
            loopProgress = (scrollPosition % halfWidth) / halfWidth;
            const easedMultiplier = easeInOut(loopProgress);
            currentSpeed = baseScrollSpeed * (0.5 + easedMultiplier * 0.5);
          }
          
          // Pulse animation (applied after easing to override if both somehow selected)
          if (scrollOptions.animation === 'pulse') {
            currentSpeed = baseScrollSpeed * (1 + Math.sin(timestamp / 1000) * 0.3);
          }

          // Smooth sub-pixel scrolling - optimized for mobile
          // Use consistent time-based calculation for fluid motion across all devices
          // Direct pixel-per-millisecond calculation for maximum smoothness
          const pixelsPerSecond = currentSpeed * 60; // Convert to pixels per second
          const normalizedSpeed = (pixelsPerSecond * deltaTime) / 1000; // Apply deltaTime in milliseconds
          
          // Apply bounce offset if bouncing
          if (scrollOptions.animation === 'bounce' && isBouncing) {
            const bounceProgress = Math.min((timestamp - bounceStartTime) / 300, 1); // 300ms bounce
            bounceOffset = easeOutBounce(1 - bounceProgress) * 30; // 30px bounce distance
            
            if (bounceProgress >= 1) {
              isBouncing = false;
              bounceOffset = 0;
            }
          } else {
            bounceOffset = 0;
          }
          
          // Direction handling - accumulate scroll position smoothly
          if (scrollOptions.direction === 'right-left') {
            scrollPosition -= normalizedSpeed;
          } else if (scrollOptions.direction === 'bidirectional' || scrollOptions.direction === 'ping-pong') {
            scrollPosition += normalizedSpeed * scrollDirection;
          } else {
            scrollPosition += normalizedSpeed;
          }
          
          // Handle loop based on direction
          if (scrollOptions.direction === 'bidirectional' || scrollOptions.direction === 'ping-pong') {
            if (scrollPosition >= maxWidth || scrollPosition <= 0) {
              // Bounce effect
              if (scrollOptions.animation === 'bounce' && !isBouncing) {
                isBouncing = true;
                bounceStartTime = timestamp;
                if (scrollPosition >= maxWidth) {
                  scrollPosition = maxWidth;
                } else {
                  scrollPosition = 0;
                }
              } else if (scrollOptions.animation !== 'bounce') {
                setScrollDirection(prev => prev * -1);
              }
            }
          } else if (scrollOptions.direction === 'right-left') {
            if (scrollPosition <= 0) {
              // Bounce effect
              if (scrollOptions.animation === 'bounce' && !isBouncing) {
                isBouncing = true;
                bounceStartTime = timestamp;
                scrollPosition = 0;
              } else if (scrollOptions.animation !== 'bounce') {
                scrollPosition = maxWidth;
              }
            }
          } else {
            // Left to right - seamless loop
            if (scrollPosition >= halfWidth) {
              // Bounce effect
              if (scrollOptions.animation === 'bounce' && !isBouncing) {
                isBouncing = true;
                bounceStartTime = timestamp;
                scrollPosition = halfWidth;
              } else if (scrollOptions.animation !== 'bounce') {
                scrollPosition = 0;
              }
            }
          }
          
          // Apply bounce offset to scroll position with sub-pixel precision
          const finalScrollPosition = scrollPosition - bounceOffset;
          
          // On mobile, use requestAnimationFrame for smoother updates
          // Direct assignment is fine, browser handles sub-pixel rendering
          scrollContainer.scrollLeft = finalScrollPosition;
          
          lastTimestamp = timestamp;
        } else {
          // When paused, maintain current scroll position
          scrollPosition = scrollContainer.scrollLeft;
          lastTimestamp = timestamp;
        }
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [isScrollingPaused, scrollDirection, isUserScrolling]);

  const whoItsForData = [
    {
      id: 'doctors',
      title: 'Doctors',
      icon: 'fas fa-user-md',
      summary: 'Create your professional practice website with key sections and tools that help patients book, contact, and trust you.',
      color: '#4E8F5A',
    },
    {
      id: 'clinics',
      title: 'Clinics',
      icon: 'fas fa-clinic-medical',
      summary: 'Manage your clinic’s online presence efficiently with structured pages and built-in features for smoother patient handling.',
      color: '#2C5F3D',
    },
    {
      id: 'hospitals',
      title: 'Hospitals',
      icon: 'fas fa-hospital',
      summary: 'Build a complete hospital website that highlights specialties and facilities while supporting operational needs.',
      color: '#1F3D2B',
    },
  ];


  // Function to render feature icon based on style
  const renderFeatureIcon = (index) => {
    switch (featureIconStyle) {
      case 'check':
        return <i className="fas fa-check-circle"></i>;
      case 'dot':
        return <i className="fas fa-circle" style={{ fontSize: '0.5rem' }}></i>;
      case 'number':
        return <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{index + 1}</span>;
      case 'dash':
        return <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>—</span>;
      case 'arrow':
        return <i className="fas fa-arrow-right"></i>;
      case 'square':
        return <i className="fas fa-square" style={{ fontSize: '0.6rem' }}></i>;
      case 'none':
        return null;
      default:
        return <i className="fas fa-check-circle"></i>;
    }
  };

  // Function to render bullet points with arrow layout
  const renderBulletPoints = (features) => {
    return (
      <div className="bullet-layout-arrow">
        {features.map((feature, idx) => (
          <div key={idx} className="bullet-arrow-item">
            <i className="fas fa-arrow-right bullet-arrow-icon"></i>
            <div className="bullet-content">
              <h5 className="feature-item-title">{feature.title}</h5>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Feature tabs data for the new features section
  const featureTabsData = [
    {
      id: 'security',
      label: 'Security',
      icon: <FaShieldAlt className="twox" />,
      featured: {
        title: 'Security, Reliability & Support Infrastructure',
        description: 'ClinTa Web Builder is built on a secure and reliable foundation that enables a healthcare website to function as a clinical-grade digital system, not just a public-facing page. It protects patient data, ensures system availability, and supports responsible digital healthcare operations. Our Security, Reliability & Support Infrastructure include:',
        highlight: 'Complete protection with 24/7 expert support'
      },
      supporting: [
        { title: 'Secure Website (SSL Protection)', description: 'Full SSL certificate implementation for encrypted data transmission and secure connections' },
        { title: 'Data Privacy & Encryption', description: 'Advanced encryption algorithms to protect sensitive healthcare data and patient information' },
        { title: 'Fast & Reliable Cloud Hosting', description: 'High-performance cloud infrastructure ensuring 99.9% uptime and fast page load speeds' },
        { title: '24/7 Technical Support', description: 'Round-the-clock assistance from our expert technical team for any issues or queries' },
        { title: 'Role-Based User Access Control', description: 'Granular permission system allowing you to control who can access what information' }
      ]
    }, 
    {
      id: 'content',
      label: 'CMS',
      icon: <BsFileText className="twox" />,
      featured: {
        title: 'Content Management System',
        description: 'ClinTa’s content and information management system enables healthcare providers to control all patient-facing and institutional content directly from a centralized administrative backend. Closely integrated with professional website creation, patient engagement, and administrative control, it ensures consistency between clinical services and public communication, reduces dependency on external developers, and supports clearer patient understanding and informed decision-making. Core elements of its Content & Information Management System are:',
        highlight: 'Complete control over your website content'
      },
      supporting: [
        { title: 'Homepage Banners', description: 'Create and manage multiple homepage banners with custom images, text, and call-to-action buttons' },
        { title: 'Specialties & Facilities', description: 'Showcase your medical specialties and facility features with detailed descriptions and images' },
        { title: 'Doctor Profile', description: 'Create comprehensive doctor profiles with qualifications, experience, specialties, and availability' },
        { title: 'Leadership Message', description: 'Display leadership messages, vision, and mission statements to build trust and credibility' },
        { title: 'Blogs & News', description: 'Publish healthcare articles, news updates, and educational content to engage visitors' },
        { title: 'Gallery', description: 'Showcase hospital facilities, events, achievements, and team photos in an organized gallery format' },
        { title: 'Social Media Intergration', description: 'Keep in touch with patients through personalized and group messaging options. Streamline administrative and marketing efforts with customizable messages, group messaging, and scheduled communications.' }
      ]
    },
    {
      id: 'uxui',
      label: 'UX/UI',
      icon: <FaPalette className="twox" />,
      featured: {
        title: 'User Experience & Interface',
        description: 'ClinTa’s UX and UI are purpose-designed for healthcare interactions, enabling patients to navigate services, book appointments, and access information with clarity and ease. The interface minimizes friction at the first point of contact, turning the website into an active engagement channel rather than a passive browsing space. Built for accessibility, consistency, and responsiveness across devices, the design reinforces patient confidence while supporting efficient interactions. Core Elements of User Experience (UX) & User Interface (UI) Design are:',
        highlight: 'Unlimited customization for your brand identity'
      },
      supporting: [
        { title: 'Layout Options', description: 'Multiple pre-designed layouts and templates to choose from or customize to your preference' },
        { title: 'Typography Settings', description: 'Customize fonts, sizes, colors, and spacing to match your brand guidelines' },
        { title: 'Color Scheme Customization', description: 'Choose from a range of color schemes to match your brand identity and create a consistent visual identity' },
        { title: 'Banner Slider Variations', description: 'Various banner slider styles including carousel, fade, and slide transitions' },
        { title: 'CTA Banners', description: 'Create compelling call-to-action banners to drive user engagement and conversions' },
        { title: 'Promotional Popups & Counters', description: 'Display promotional messages, announcements, and visitor counters to enhance engagement' },
        { title: 'Admin Help Guide', description: 'Comprehensive help documentation and guides to assist administrators in managing the website' }
      ]
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: <BsGraphUp className="twox" />,
      featured: {
        title: 'User Activity & Analytics',
        description: 'ClinTa’s user activity and analytics capabilities provide healthcare administrators with clear visibility into patient interactions, website usage, and system-level activity. By capturing and organizing digital behavior within the same platform that manages appointments and workflows, ClinTa transforms routine data into actionable administrative insight. This enables informed decision-making, strengthens accountability, and supports continuous improvement of patient engagement and operational efficiency. Following are the core elements of User Activity & Analytics:',
        highlight: 'Data-driven insights for better decision making'
      },
      supporting: [
        { title: 'Visitor Activity Status', description: 'Monitor real-time visitor activity, page views, and user engagement metrics' },
        { title: 'Patient Inquiry Tracking', description: 'Track and manage patient inquiries, contact forms, and appointment requests' },
        { title: 'Appointment Management', description: 'Comprehensive appointment scheduling system with calendar integration and reminders' },
        { title: 'Registered Patient Records', description: 'Maintain organized records of registered patients with search and filter capabilities' },
        { title: 'Doctor Profile and Availability', description: 'Manage doctor profiles, schedules, and availability status in real-time' },
        { title: 'Billing History', description: 'Track billing transactions, invoices, and payment history for financial management' }
      ]
    },
    {
      id: 'communication',
      label: 'Integrated Communication',
      icon: <IoChatbubblesOutline className="twox" />,
      featured: {
        title: 'Integrated Communication System',
        description: 'ClinTa embeds patient communication directly into the website and operational backend, enabling automated notifications, reminders, and follow-ups through SMS, email, and WhatsApp. By linking communication with appointments and clinical workflows, every message remains timely, relevant, and context-aware. Following are its core elements of integrated communication system:',
        highlight: 'Stay connected with patients through multiple channels'
      },
      supporting: [
        { title: 'SMS Notifications', description: 'Send automated SMS notifications for appointments, reminders, and important updates' },
        { title: 'Email Communication', description: 'Send personalized emails, newsletters, and automated notifications to patients' },
        { title: 'WhatsApp Instant Chat', description: 'Enable real-time WhatsApp chat integration for instant patient communication and support' }
      ]
    },
    {
      id: 'value',
      label: 'VAS',
      icon: <BsGift className="twox" />,
      featured: {
        title: 'Value-Added Services',
        description: 'ClinTa goes beyond building a website or managing routine workflows by offering additional services that make healthcare access easier, communication smoother, and the digital presence more effective. Unlike conventional systems that rely on multiple external tools or vendors, these services are built directly into the platform—so doctors, clinics, and hospitals can enhance patient experience and visibility without added complexity. Following are its core elements:',
        highlight: 'Advanced features that add real value to your practice'
      },
      supporting: [
        { title: 'Online Appointment Booking', description: 'Allow patients to book appointments online with real-time availability and confirmation' },
        { title: 'OPD Invoicing System', description: 'Generate and manage OPD invoices directly through the website with integrated billing' },
        { title: 'E-Prescription Module', description: 'Create and manage electronic prescriptions with digital signatures and patient access' },
        { title: 'Dynamic SEO Controls', description: 'Optimize your website for search engines with customizable meta tags, descriptions, and keywords' }
      ]
    },
    {
      id: 'portals',
      label: 'Portals',
      icon: <FaDoorOpen className="twox" />,
      featured: {
        title: 'Integrated Portals',
        description: 'ClinTa Web Builder redefines the role of a healthcare website by transforming it into a secure, role-based web portal ecosystem rather than a static information page. Unlike traditional websites that only display content, ClinTa enables real interaction, data continuity, and controlled access, hence allowing patients, doctors, and administrators to log in, manage information, and perform actions within the same system. Following are the portals integrated within the system:',
        highlight: 'Dedicated portals for every user type'
      },
      supporting: [
        { title: 'Patient Portal', description: 'Secure patient portal for accessing medical records, test results, appointments, and billing information' },
        { title: 'Doctor Portal', description: 'Dedicated portal for doctors to manage schedules, view patient records, and access clinical tools' },
        { title: 'Administrative Portal', description: 'Comprehensive admin portal for managing website content, users, settings, and system configuration' },
        { title: 'Recruitment Portal', description: 'Integrated HR portal for job postings, CV management, interview scheduling, and candidate tracking' }
      ]
    }
  ];

  // Client logos data for "Trusted by Healthcare Providers" section
  const clientLogos = [
    {
      name: 'Dental Specialists',
      logo: '/assets/img/customers/dental-specialists.png',
      website: 'https://dentalspec.org/'
    },
    {
      name: 'Best Gastro and Liver Clinic',
      logo: '/assets/img/customers/best-gastro.png',
      website: 'https://bestgastoliverclinic.com/'
    },
    {
      name: 'Defence Physio & Medix Care',
      logo: '/assets/img/customers/defence-physio-care.png',
      website: 'https://defencephysiocare.org/'
    },
    {
      name: 'Dental Aesthetic Clinic',
      logo: '/assets/img/customers/dental-aesthetic-clinic.png',
      website: 'https://dentalaestheticclinic.com/'
    },
    
    {
      name: 'Rathore Medical Complex',
      logo: '/assets/img/customers/rathore-medical-complex.png',
      website: 'https://rathoremedicalcomplex.com/'
    },
    {
      name: 'Dr. Sohail Skin & Laser Clinic',
      logo: '/assets/img/customers/sohail-aesthetics.png',
      website: 'https://drsohailskinlasers.com/'
    },
    {
      name: 'Life Beat',
      logo: '/assets/img/customers/life-beat.png',
      website: 'https://thelifebeat.pk/'
    },
    {
      name: 'Dr. Ahmed Clinic',
      logo: '/assets/img/customers/ahmed-clinic.png',
      website: 'https://drahmedclinic.clinta.biz/'
    }
  ];

  const features = [
    {
      icon: <FaDisplay className="twox" />,
      title: "Display",
      description:
        "The front end of ClinTa Web-Builder ensures an engaging and informative experience for visitors. It showcases hospitals, doctors, and labs with attractive profiles, highlighting facilities and services offered in an attractive manner.",
    },
    {
      icon: <BsSpeedometer className="twox" />,
      title: "Dashboard",
      description:
        "Whether an administrator or a visitor, our dedicated dashboard provides easy access to essential features and information. Seamlessly navigate through your website or manage content with built-in controls.",
    },
    {
      icon: <FaUserLock className="twox" />,
      title: "Access Levels",
      description:
        "With multiple administrators supported by ClinTa Web-Builder, you can assign varying levels of authority and control. This feature ensures efficient management of website operations and content moderation.",
    },
    {
      icon: <BsHeartPulse className="twox" />,
      title: "E-Health",
      description:
        "Access premium teleconsultation with e-Health, designed for top-tier clients. Experience seamless doctor-patient interactions, detailed consultation notes, and two-way communication for superior healthcare.",
    },
    {
      icon: <FaChalkboardTeacher className="twox" />,
      title: "Profiling",
      description:
        "Hospitals, laboratories, and doctors can create personalized profiles to showcase their expertise and services effectively. Present yourself professionally to visitors and establish credibility within the healthcare community.",
    },
    {
      icon: <BsCheck2Circle className="twox" />,
      title: "Permissions",
      description:
        "It enables to take full control of your website's content visibility with customizable permissions. Decide what information is accessible to visitors, ensuring a tailored and secure browsing experience.",
    },
    {
      icon: <BsChatRightText className="twox" />,
      title: "Patient Reviews",
      description:
        "Gather authentic feedback from visitors through patient reviews. Moderated by website owners, these reviews enhance transparency and credibility while preventing malicious content.",
    },
    {
      icon: <BsCalendar4Week className="twox" />,
      title: "Appointment Panel",
      description:
        "Streamline appointment scheduling with our versatile appointment panel, offering slot-based or approval-dependent booking for enhanced convenience and patient satisfaction.",
    },
    {
      icon: <BsArchive className="twox" />,
      title: "Patient Archives",
      description:
        "Keep track of appointment bookings with a comprehensive patient archives feature. Maintain organized logs for efficient record-keeping and management.",
    },
    {
      icon: <IoImagesOutline className="twox" />,
      title: "Gallery",
      description:
        "Showcase hospital events, doctor achievements, and laboratory highlights with an engaging gallery feature. Captivate visitors with visual storytelling and create a sense of being a vital and integral community component.",
    },
    {
      icon: <IoChatbubblesOutline className="twox" />,
      title: "SMS Services",
      description:
        "Keep in touch with patients through personalized and group messaging options. Streamline administrative and marketing efforts with customizable messages, group messaging, and scheduled communications.",
    },
    {
      icon: <BsFileEarmarkArrowUp className="twox" />,
      title: "Digital Archives",
      description:
        "Empower doctors with a dedicated platform for research and academic work. Save, group, highlight, and retrieve academic and research data seamlessly to support professional growth and knowledge sharing.",
    },
    {
      icon: <BsFilePerson className="twox" />,
      title: "CV Builder",
      description:
        "Exclusive to doctors, our CV builder simplifies the creation of professional CVs in various formats. Seamlessly integrate web profile information with a click of a button, streamlining and optimizing the CV creation process.",
    },
    {
      icon: <BiSupport className="twox" />,
      title: "Support",
      description:
        "Access comprehensive support resources, from instructional videos to direct assistance from our team. Enjoy peace of mind as technical issues are promptly resolved, ensuring a seamless website-building experience.",
    },
  ];

  return (
    <>
      <Header />

      <div className="main webbuilder-page">
        {/* Hero Section */}
        <WebBuilderHero />
        
        {/* Who it's for Section */}
        <section className="who-its-for-section wb-providers-section wb-providers-icon-title ptb-100 section-below-banner gray-light-bg">
          <div className="container wb-providers-intro-wrap">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-10 mb-4" style={{ textAlign: "center" }}>
                <h2 className="web mb-3">Designed for Providers at Every Scale</h2>
                <p>
                Explore how Web Builder adapts to different healthcare environments by offering professional website sections and integrated tools that improve both visibility and operations.
                </p>
              </div>
            </div>

            {/* Cards Container – Grid, Icon + Title only */}
            <div className="who-its-for-cards-container layout-grid">
              {whoItsForData.map((item, index) => (
                <div
                  key={item.id}
                  className="who-its-for-card-wrapper"
                  onMouseEnter={() => setHoveredCard(item.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div 
                    className={`who-its-for-card-modern ${hoveredCard === item.id ? 'hovered' : ''}`}
                    style={{ '--card-color': item.color }}
                  >
                    <div className="card-modern-content">
                      <div className="card-icon-wrapper">
                        <div className="card-icon">
                          <i className={item.icon} style={{ color: item.color }}></i>
                        </div>
                      </div>
                      <h4 className={showProviderSummary ? 'mb-3' : 'mb-0'}>{item.title}</h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section with Tabs */}
        <section className="features-tabs-section ptb-50 gray-light-bg healthcare-features-section">
          <div className="container">
            <div className="row justify-content-center mb-3">
              <div className="col-md-10 col-lg-8 text-center">
                <h2 className="web mb-0">Healthcare-Ready Website Features</h2>
              </div>
            </div>


            {/* Feature Tabs */}
            <div className="row">
              <div className="col-12">
                <div className="feature-tabs-container layout-card">
                  {/* Mobile Dropdown - Only visible on mobile */}
                  <div className="feature-dropdown-mobile d-lg-none mb-3" ref={dropdownRef}>
                    <button
                      className="feature-dropdown-toggle"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      type="button"
                    >
                      <span>{featureTabsData[activeFeatureTab].label}</span>
                      <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
                    </button>
                    {isDropdownOpen && (
                      <div className="feature-dropdown-menu">
                        {featureTabsData.map((tab, index) => (
                          <button
                            key={tab.id}
                            className={`feature-dropdown-item ${activeFeatureTab === index ? 'active' : ''}`}
                            onClick={() => {
                              setActiveFeatureTab(index);
                              setIsDropdownOpen(false);
                            }}
                            type="button"
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Tab Navigation - Only visible on desktop */}
                  <div className="feature-tabs-nav tabs-style-card d-none d-lg-flex">
                    {featureTabsData.map((tab, index) => (
                      <button
                        key={tab.id}
                        className={`feature-tab ${activeFeatureTab === index ? 'active' : ''}`}
                        onClick={() => setActiveFeatureTab(index)}
                      >
                        <span className="tab-label">{tab.label}</span>
                      </button>
                    ))}
                  </div>

                  {/* Tab Content */}
                  <div className="feature-tab-content-wrapper mt-4">
                    {featureTabsData.map((tab, index) => (
                      <div
                        key={tab.id}
                        className={`feature-tab-content ${activeFeatureTab === index ? 'active' : ''}`}
                      >
                        <div className="row align-items-center">
                          {/* Left Side - Featured Highlight */}
                          <div className="col-lg-7 col-md-12 mb-1 mb-lg-0">
                            <div className="featured-panel featured-panel-card">
                              <div className="featured-panel-content">
                                <h3 className="featured-title mb-3">{tab.featured.title}</h3>
                                <p className="featured-description mb-0">{tab.featured.description}</p>
                              </div>
                            </div>
                          </div>

                          {/* Right Side - Supporting Features List */}
                          <div className="col-lg-5 col-md-12">
                            <div className="supporting-features supporting-features-card">
                              {renderBulletPoints(tab.supporting)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 1: Trusted by Healthcare Providers */}
        <section id="trusted-providers" className="trusted-providers-section gray-light-bg ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 text-center">
                <div className="section-heading mb-3">
                  <h2 className="web">Trusted by Healthcare Providers</h2>
                  <p className="text-muted para-desc mb-0 mx-auto">
                    Join hundreds of healthcare providers who trust ClinTa Web-Builder to power their online presence
                  </p>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12">
                <div 
                  className="client-logo-scroll visual-scale"
                  ref={logoScrollRef}
                >
                  {/* Duplicate logos for seamless infinite scroll */}
                  {[...clientLogos, ...clientLogos].map((client, index) => (
                    <a
                      key={index}
                      href={client.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="client-logo-item"
                      aria-label={isMobileTouch ? (isScrollingPaused ? `Visit ${client.name} website` : `Tap to pause, tap again to visit`) : `Visit ${client.name} website`}
                      onMouseEnter={() => {
                        if (!isMobileTouch) {
                          setIsScrollingPaused(true);
                        }
                      }}
                      onMouseLeave={() => {
                        if (!isMobileTouch) {
                          setIsScrollingPaused(false);
                        }
                      }}
                      onClick={(e) => {
                        if (!isMobileTouch) return;
                        if (!isScrollingPaused) {
                          e.preventDefault();
                          e.stopPropagation();
                          setIsScrollingPaused(true);
                          // Auto-resume after 3 seconds on mobile
                          setTimeout(() => {
                            setIsScrollingPaused(false);
                          }, 3000);
                        } else {
                          // Already paused, allow link to open
                          setIsScrollingPaused(false);
                        }
                      }}
                    >
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="client-logo-img"
                      />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Plans & Pricing */}
        <WebBuilderPricingSection />

        {/* Section 3: Frequently Asked Questions */}
        <section id="faq" className="wb-faq-section gray-light-bg ptb-100 webbuilder-faq-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">
                <div className="section-heading text-center mb-4">
                  <h2 className="web">Frequently Asked Questions</h2>
                </div>
              </div>
            </div>
            <div className="row align-items-start g-4 g-lg-5">
              <div className="col-lg-7 col-12">
                <div className="wb-faq-layout wb-faq-layout-modern">
                {webBuilderFaqData?.map((item, index) => (
                  <div
                    key={index}
                    className={`wb-faq-item ${activeAccordion === index ? "is-open" : ""}`}
                  >
                    <button
                      type="button"
                      className="wb-faq-trigger"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={activeAccordion === index}
                    >
                      <span className="wb-faq-question">{item.question}</span>
                      <span className="wb-faq-chevron" aria-hidden="true">
                        <BsChevronDown size={14} />
                      </span>
                    </button>
                    <div className="wb-faq-content">
                      <div className="wb-faq-body">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
                </div>
              </div>
              <div className="col-lg-5 col-12">
                <div className="wb-faq-cta">
                  <h3 className="wb-faq-cta-title">Still have questions?</h3>
                  <p className="wb-faq-cta-text">
                    Request a demo to see ClinTa Web-Builder in action, or explore our full FAQ library for more answers.
                  </p>
                  <div className="wb-faq-cta-btns">
                    <Link to="/request-a-demo?product=Web-Builder" className="wb-faq-cta-btn wb-faq-cta-btn-primary">
                      Request a demo
                    </Link>
                    <Link to="/faqs?category=Web-Builder" className="wb-faq-cta-btn wb-faq-cta-btn-outline">
                      View all FAQs
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="promo-block ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className="col-md-10 col-lg-10 mb-4"
                style={{ textAlign: "center" }}
              >
                <h2 className="web">Why to Choose ClinTa Web-Builder?</h2>
                <p>
                Experience seamless website creation with integrated EMRs, interactive patient portals, SSL certification, encrypted data, and scalable solutions tailored for healthcare professionals and institutions.
                </p>
              </div>

              {promosData?.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div
                    className={`promo-one-single-web shadow-lg webbuilder-choose-cards curr-pointer ${
                      index === expandedIndex
                        ? "promo-one-single-web-orange"
                        : ""
                    }`}
                    onClick={(event) => handleClick(index, event)}
                  >
                    <img
                      src={item?.icon}
                      alt="promo"
                      className="mb-4"
                      width="65"
                    />
                    <h5>{item?.title}</h5>

                    <p className="mb-0">
                      {expandedIndex === index
                        ? item?.content
                        : truncateText(item?.content, 133)}
                    </p>
                    {item?.content?.length > 133 && (
                      <a
                        className="icon-link accent-web-bg webbuilder-cards-icon"
                        onClick={(event) => handleClick(index, event)}
                      >
                        {expandedIndex !== index ? (
                          <span className="ti-angle-double-right"></span>
                        ) : (
                          <span className="ti-angle-double-left"></span>
                        )}
                        <div className="webbuilder-cards-text">
                          {expandedIndex === index
                            ? " Read Less"
                            : " Read More"}
                        </div>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}
        {/* <section
          id="features"
          className="feature-section ptb-100 gray-light-bg"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2 className="web">Web Builder Features</h2>
                  <p className="text-muted para-desc mb-0 mx-auto">
                    Following are important features of ClinTa Web-Builder which
                    differentiates itself from other web builders and also from
                    general website developed in the market:
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="row">
                  {features?.map((feature, index) => (
                    <div className="col-md-4 col-12" key={index}>
                      <div className="features-single-wrap mb-sm-0 mb-md-5 mb-lg-5">
                        <div className="features-single-content d-block overflow-hidden">
                          <h5 className="mb-3">
                            {feature?.icon} {feature?.title}
                          </h5>
                          <p className="text-justify">{feature?.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section> */}


        {/* <section
          id="process"
          className="work-process-section position-relative  ptb-100"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2 className="web">Advanced HR Features</h2>
                  <p>
                    ClinTa Web-Builder not only enables healthcare providers to
                    create professional websites effortlessly but also
                    integrates powerful HR features to streamline the
                    recruitment process.
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center justify-content-md-center justify-content-sm-center">
              <div className="col-md-12 col-lg-6">
                <div className="work-process-wrap">
                  <div className="process-single-item">
                    <div className="process-icon-item left-shape">
                      <div className="d-flex align-items-center">
                        <div className="process-icon mr-4">
                          <i className="fas fa-project-diagram color-primary"></i>
                        </div>
                    `  <div className="process-content text-left">
                        <h5>Job Posting</h5>
                          <p>
                            - Publish job openings directly on your website. <br />
                          - Customize job listings with detailed descriptions and requirements.
                          </p>
                        </div>
            
                      <svg x="0px" y="0px" width="312px" height="130px">
                        <path
                          className="dashed1"
                          fill="none"
                          stroke="rgb(95, 93, 93)"
                          stroke-width="1"
                          stroke-dasharray="1300"
                          stroke-dashoffset="0"
                          d="M3.121,2.028 C3.121,2.028 1.003,124.928 99.352,81.226 C99.352,81.226 272.319,21.200 310.000,127.338"
                        ></path>
                        <path
                          className="dashed2"
                          fill="none"
                          stroke="#ffffff"
                          stroke-width="2"
                          stroke-dasharray="6"
                          stroke-dashoffset="1300"
                          d="M3.121,2.028 C3.121,2.028 1.003,124.928 99.352,81.226 C99.352,81.226 272.319,21.200 310.000,127.338 "
                        ></path>
                      </svg>
                      
                    </div>
                  </div>
                  <div className="process-single-item">
                    <div className="process-icon-item right-shape">
                      <div className="d-flex align-items-center">
                        {/*<div className="process-icon ml-4">
                          <i className="fas fa-puzzle-piece color-primary"></i>
                        </div>
                        
                        <div className="process-content text-right">
                          <h5>2. CV Management</h5>
                          <p>
                            - Receive applications directly within the admin
                            panel. <br />
                            - Filter and organize CVs based on specific
                            criteria of department (for which CV is submitted),
                            qualification, experience, gender and age group. <br />
                            - View CVs separately for interviewed and
                            non-interviewed candidates.
                          </p>
                        </div>
                      </div>
                      {/*
                      <svg x="0px" y="0px" width="312px" height="130px">
                        <path
                          className="dashed1"
                          fill="none"
                          stroke="rgb(95, 93, 93)"
                          stroke-width="1"
                          stroke-dasharray="1300"
                          stroke-dashoffset="0"
                          d="M311.000,0.997 C311.000,0.997 313.123,123.592 214.535,79.996 C214.535,79.996 41.149,20.122 3.377,125.996"
                        ></path>
                        <path
                          className="dashed2"
                          fill="none"
                          stroke="#ffffff"
                          stroke-width="2"
                          stroke-dasharray="6"
                          stroke-dashoffset="1300"
                          d="M311.000,0.997 C311.000,0.997 313.123,123.592 214.535,79.996 C214.535,79.996 41.149,20.122 3.377,125.996"
                        ></path>
                      </svg>
                    
                    </div>
                  </div>
                  <div className="process-single-item">
                    <div className="process-icon-item left-shape">
                      <div className="d-flex align-items-center">
                        {/*
                        <div className="process-icon mr-4">
                          <i className="fas fa-truck color-primary"></i>
                        </div>
                        <div className="process-content text-left">
                          <h5>3. Interview Scheduling</h5>
                          <p>
                            - Schedule interviews seamlessly through the admin
                            panel. <br />
                            - Manage interview timings and notify
                            candidates directly from the website.
                          </p>
                        </div>
                      </div>
                      {/*
                      <svg x="0px" y="0px" width="312px" height="130px">
                        <path
                          className="dashed1"
                          fill="none"
                          stroke="rgb(95, 93, 93)"
                          stroke-width="1"
                          stroke-dasharray="1300"
                          stroke-dashoffset="0"
                          d="M3.121,2.028 C3.121,2.028 1.003,124.928 99.352,81.226 C99.352,81.226 272.319,21.200 310.000,127.338"
                        ></path>
                        <path
                          className="dashed2"
                          fill="none"
                          stroke="#ffffff"
                          stroke-width="2"
                          stroke-dasharray="6"
                          stroke-dashoffset="1300"
                          d="M3.121,2.028 C3.121,2.028 1.003,124.928 99.352,81.226 C99.352,81.226 272.319,21.200 310.000,127.338 "
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="process-single-item">
                    <div className="process-icon-item right-shape">
                      <div className="d-flex align-items-center">
                        {/*
                        <div className="process-icon ml-4">
                          <i className="fas fa-puzzle-piece color-primary"></i>
                        </div>
                        <div className="process-content text-right">
                          <h5>4. Candidate Categorization</h5>
                          <p>
                            - Mark interviewed candidates into four categories: A,
                            B, C and D. <br />
                            - Use the categorization for efficient
                            long listing and shortlisting.
                          </p>
                        </div>
                      </div>
                      {/*
                      <svg x="0px" y="0px" width="312px" height="130px">
                        <path
                          className="dashed1"
                          fill="none"
                          stroke="rgb(95, 93, 93)"
                          stroke-width="1"
                          stroke-dasharray="1300"
                          stroke-dashoffset="0"
                          d="M311.000,0.997 C311.000,0.997 313.123,123.592 214.535,79.996 C214.535,79.996 41.149,20.122 3.377,125.996"
                        ></path>
                        <path
                          className="dashed2"
                          fill="none"
                          stroke="#ffffff"
                          stroke-width="2"
                          stroke-dasharray="6"
                          stroke-dashoffset="1300"
                          d="M311.000,0.997 C311.000,0.997 313.123,123.592 214.535,79.996 C214.535,79.996 41.149,20.122 3.377,125.996"
                        ></path>
                      </svg>
                    </div>
                  </div>

                  <div className="process-single-item">
                    <div className="process-icon-item left-shape mb-0">
                      <div className="d-flex align-items-center">
                        {/*
                        <div className="process-icon mr-4">
                          <i className="fas fa-truck color-primary"></i>
                        </div>
                        <div className="process-content text-left">
                          <h5>5. Candidate Remarks and Finalization</h5>
                          <p>
                            - Add remarks and notes for each candidate for future
                            reference. <br />
                            - Communicate decisions to candidates
                            through auto email system or website’s integrated
                            messaging system.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="img-wrap">
                  <img
                    src="/assets/img/advanced-features.png"
                    alt="features"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="position-relative feature-section ptb-80 gray-light-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-12 col-lg-6">
                <div className="feature-contents section-heading">
                  <h2 className="web">Benefits of HR Module</h2>
                  <p>
                  Empower your HR team with an all-in-one solution that simplifies recruitment, enhances organization, and streamlines communication.
                  </p>
                  <ul className="dot-circle pt-2">
                    <li>
                    <b>Streamlined Recruitment Process:</b> Manage job postings, applications, and interviews all in one place. 
                    </li>
                    <li>
                    <b>Enhanced Organization:</b> Easily categorize and track candidates for better decision making. 
                    </li>
                    <li>
                    <b>Efficient Communication:</b> Directly communicate with candidates through the website, reducing delays and improving transparency.  
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="download-img">
                  <img
                    src="/assets/img/hr-benefits.png"
                    alt="download"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="background-image-wraper"
            style={{
              background: ` url('/assets/img/cta-bg.jpg')no-repeat center center / cover fixed`,
              opacity: "1",
            }}
          ></div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-1 text-white">
                  <h2 className="text-white">Download Our Apps</h2>
                  <p>
                    Start working with that can provide everything you need to
                    generate awareness, drive traffic, connect. Efficiently
                    transform granular value with client-focused content.
                    Energistically redefine market.
                  </p>
                  <div className="action-btns">
                    <ul className="list-inline">
                      <li className="list-inline-item my-2">
                        <a
                          href="#"
                          className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                        >
                          <span className="fab fa-windows icon-size-sm mr-3"></span>
                          <div className="download-text text-left">
                            <small>Download form</small>
                            <h5 className="mb-0">Windows</h5>
                          </div>
                        </a>
                      </li>
                      <li className="list-inline-item my-2">
                        <a
                          href="#"
                          className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                        >
                          <span className="fab fa-apple icon-size-sm mr-3"></span>
                          <div className="download-text text-left">
                            <small>Download form</small>
                            <h5 className="mb-0">App Store</h5>
                          </div>
                        </a>
                      </li>
                      <li className="list-inline-item my-2">
                        <a
                          href="#"
                          className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                        >
                          <span className="fab fa-google-play icon-size-sm mr-3"></span>
                          <div className="download-text text-left">
                            <small>Download form</small>
                            <h5 className="mb-0">Google Play</h5>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* <PricingTableSecond product="builder" /> */}
        {/* <section id="pricing" className="pricing-section ptb-100 ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-9 col-lg-8">
                                <div className="section-heading text-center mb-4">
                                    <h2>Our Flexible Price</h2>
                                    <p>
                                        Professional hosting at an affordable price. Distinctively recaptiualize principle-centered
                                        core competencies through client-centered
                                        core competencies.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-md-center justify-content-center">
                            <div className="col-12">
                                <div className="d-flex justify-content-center text-center">
                                    <label className="pricing-switch-wrap">
                                        <span className="beforeinput year-switch text-success">
                                            Monthly
                                        </span>
                                        <input type="checkbox" className="d-none" id="js-contcheckbox" />
                                        <span className="switch-icon"></span>
                                        <span className="afterinput year-switch">
                                            Yearly
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-8">
                                <div className="text-center bg-white single-pricing-pack mt-4">
                                    <div className="price-img pt-4">
                                        <img src="assets/img/priching-img-1.png" alt="price" width="120" className="img-fluid" />
                                    </div>
                                    <div className="py-4 border-0 pricing-header">
                                        <div className="price text-center mb-0 monthly-price color-secondary" style={{ display: "block" }}>$19<span>.99</span></div>
                                        <div className="price text-center mb-0 yearly-price color-secondary" style={{ display: "none" }}>$69<span>.99</span></div>
                                    </div>
                                    <div className="price-name">
                                        <h5 className="mb-0">Standard</h5>
                                    </div>
                                    <div className="pricing-content">
                                        <ul className="list-unstyled mb-4 pricing-feature-list">
                                            <li><span>Limited</span> access for a month</li>
                                            <li><span>15</span> customize sub page</li>
                                            <li className="text-deem"><span>105</span> disk space</li>
                                            <li className="text-deem"><span>3</span> domain access</li>
                                            <li className="text-deem">24/7 phone support</li>
                                        </ul>
                                        <a href="#" className="btn btn-outline-brand-02 btn-rounded mb-3" target="_blank">Purchase now</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-8">
                                <div className="popular-price bg-white text-center single-pricing-pack mt-4">
                                    <div className="price-img pt-4">
                                        <img src="assets/img/priching-img-2.png" alt="price" width="120" className="img-fluid" />
                                    </div>
                                    <div className="py-4 border-0 pricing-header">
                                        <div className="price text-center mb-0 monthly-price color-secondary" style={{ display: "block" }}>$49<span>.99</span></div>
                                        <div className="price text-center mb-0 yearly-price color-secondary" style={{ display: "none" }}>$159<span>.99</span></div>
                                    </div>
                                    <div className="price-name">
                                        <h5 className="mb-0">Premium</h5>
                                    </div>
                                    <div className="pricing-content">
                                        <ul className="list-unstyled mb-4 pricing-feature-list">
                                            <li><span>Unlimited</span> access for a month</li>
                                            <li><span>25</span> customize sub page</li>
                                            <li><span>150</span> disk space</li>
                                            <li className="text-deem"><span>5</span> domain access</li>
                                            <li className="text-deem">24/7 phone support</li>
                                        </ul>
                                        <a href="#" className="btn btn-brand-02 btn-rounded mb-3" target="_blank">Purchase now</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-8">
                                <div className="text-center bg-white single-pricing-pack mt-4">
                                    <div className="price-img pt-4">
                                        <img src="assets/img/priching-img-3.png" alt="price" width="120" className="img-fluid" />
                                    </div>
                                    <div className="py-4 border-0 pricing-header">
                                        <div className="price text-center mb-0 monthly-price color-secondary" style={{ display: "block" }}>$69<span>.99</span></div>
                                        <div className="price text-center mb-0 yearly-price color-secondary" style={{ display: "none" }}>$259<span>.99</span></div>
                                    </div>
                                    <div className="price-name">
                                        <h5 className="mb-0">Unlimited</h5>
                                    </div>
                                    <div className="pricing-content">
                                        <ul className="list-unstyled mb-4 pricing-feature-list">
                                            <li><span>Limited</span> access for a month</li>
                                            <li><span>15</span> customize sub page</li>
                                            <li><span>120</span> disk space</li>
                                            <li><span>5</span> domain access</li>
                                            <li>24/7 phone support</li>
                                        </ul>
                                        <a href="#" className="btn btn-outline-brand-02 btn-rounded mb-3" target="_blank">Purchase now</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="support-cta text-center mt-5">
                                    <h5 className="mb-1"><span className="ti-headphone-alt color-primary mr-3"></span>We're Here to Help You
                                    </h5>
                                    <p>Have some questions? <a href="#">Chat with us now</a>, or <a href="#">send us an email</a> to
                                        get in touch.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
        {/* <section className="counter-section gradient-bg ptb-40">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-3">
                <div className="text-white p-2 count-data text-center my-3">
                  <span className="fas fa-users icon-size-lg mb-2"></span>
                  <h3 className="count-number mb-1 text-white font-weight-bolder">
                    21023
                  </h3>
                  <span>Customers</span>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3">
                <div className="text-white p-2 count-data text-center my-3">
                  <span className="fas fa-cloud-download-alt icon-size-lg mb-2"></span>
                  <h3 className="count-number mb-1 text-white font-weight-bolder">
                    44023
                  </h3>
                  <span>Downloads</span>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3">
                <div className="text-white p-2 count-data text-center my-3">
                  <span className="fas fa-smile icon-size-lg mb-2"></span>
                  <h3 className="count-number mb-1 text-white font-weight-bolder">
                    35023
                  </h3>
                  <span>Satisfied</span>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3">
                <div className="text-white p-2 count-data text-center my-3">
                  <span className="fas fa-mug-hot icon-size-lg mb-2"></span>
                  <h3 className="count-number mb-1 text-white font-weight-bolder">
                    2323
                  </h3>
                  <span>Cup of Coffee</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="team-two-section ptb-100 ">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center">
                  <h2>Our Team Members</h2>
                  <p>
                    Authoritatively mesh intuitive paradigms vis-a-vis
                    goal-oriented partnerships. Continually extend open-source
                    outside the box thinking after focused catalysts.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                  <img
                    src="assets/img/team/team-member-1.png"
                    alt="team image"
                    width="120"
                    className="img-fluid m-auto pb-4"
                  />
                  <div className="team-content">
                    <h5 className="mb-0">Richard Ford</h5>
                    <span>Instructor of Mathematics</span>
                    <p className="mt-3">
                      Authoritatively engage leading-edge processes tactical
                      capital{" "}
                    </p>
                    <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                      <li className="list-inline-item">
                        <a className="facebook" href="#" target="_blank">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="twitter" href="#" target="_blank">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="dribbble" href="#" target="_blank">
                          <i className="fab fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="linkedin" href="#" target="_blank">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                  <img
                    src="assets/img/team/team-member-2.png"
                    alt="team image"
                    width="120"
                    className="img-fluid m-auto pb-4"
                  />
                  <div className="team-content">
                    <h5 className="mb-0">Kely Roy</h5>
                    <span>Lead Designer</span>
                    <p className="mt-3">
                      Monotonectally engage sticky collaborative markets
                      synergistically
                    </p>
                    <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                      <li className="list-inline-item">
                        <a className="facebook" href="#" target="_blank">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="twitter" href="#" target="_blank">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="dribbble" href="#" target="_blank">
                          <i className="fab fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="linkedin" href="#" target="_blank">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                  <img
                    src="assets/img/team/team-member-3.png"
                    alt="team image"
                    width="120"
                    className="img-fluid m-auto pb-4"
                  />
                  <div className="team-content">
                    <h5 className="mb-0">Gerald Nichols</h5>
                    <span>Managing Director</span>
                    <p className="mt-3">
                      Assertively procrastinate standardized whereas technically
                      sound
                    </p>
                    <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                      <li className="list-inline-item">
                        <a className="facebook" href="#" target="_blank">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="twitter" href="#" target="_blank">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="dribbble" href="#" target="_blank">
                          <i className="fab fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="linkedin" href="#" target="_blank">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                  <img
                    src="assets/img/team/team-member-4.png"
                    alt="team image"
                    width="120"
                    className="img-fluid m-auto pb-4"
                  />
                  <div className="team-content">
                    <h5 className="mb-0">Gerald Nichols</h5>
                    <span>Team Manager</span>
                    <p className="mt-3">
                      Synergistically actualize out the-box technologies before
                      parallel process
                    </p>
                    <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                      <li className="list-inline-item">
                        <a className="facebook" href="#" target="_blank">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="twitter" href="#" target="_blank">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="dribbble" href="#" target="_blank">
                          <i className="fab fa-dribbble"></i>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="linkedin" href="#" target="_blank">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* <PricingPlans/> */}
        {/* Commented out: existing FAQ section (now using FAQs below Trusted by Healthcare Providers)
        <section id="faq" className="ptb-100 white-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-12">
                <div className="section-heading text-center mb-5">
                  <h2 className="web">Frequently Asked Queries</h2>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-12">
                <div className="row">
                  {faqData?.map((item, index) => (
                    <div className="col-md-6">
                      <div id="accordion" className="accordion faq-wrap">
                        <div className="card my-3" key={index}>
                          <div
                            className={`card-header ${
                              activeAccordion === index
                                ? "web-color"
                                : "collapsed"
                            }`}
                            onClick={() => toggleAccordion(index)}
                          >
                            <h6 className="mb-0 d-inline-block webbuilder-faq-title">
                              {item.question}
                            </h6>
                          </div>
                          <div
                            className={`collapse ${
                              activeAccordion === index ? "show" : ""
                            }`}
                            aria-labelledby={`heading${index}`}
                            data-parent="#accordion"
                          >
                            <div className="card-body white-bg">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        */}
        {/* <section className="position-relative gradient-bg ptb-100">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-5 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                <div className="testimonial-heading text-white">
                  <h2 className="text-white">
                    What Our Client Say About Apdash
                  </h2>
                  <p>
                    Collaboratively actualize excellent schemas without
                    effective models. Synergistically engineer functionalized
                    applications rather than backend e-commerce.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="testimonial-content-wrap">
                  <div className="owl-carousel owl-theme client-testimonial-1 dot-indicator testimonial-shape">
                    <div className="item">
                      <div className="testimonial-quote-wrap">
                        <div className="media author-info mb-3">
                          <div className="author-img mr-3">
                            <img
                              src="assets/img/client/1.jpg"
                              alt="client"
                              className="img-fluid"
                            />
                          </div>
                          <div className="media-body text-white">
                            <h5 className="mb-0 text-white">John Charles</h5>
                            <span>Head Of Admin</span>
                          </div>
                          <i className="fas fa-quote-right text-white"></i>
                        </div>
                        <div className="client-say text-white">
                          <p>
                            Interactively optimize fully researched expertise
                            vis-a-vis plug-and-play relationships. Intrinsicly
                            develop viral core competencies for fully tested
                            customer service. Enthusiastically create
                            next-generation growth strategies and.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <div className="testimonial-quote-wrap">
                        <div className="media author-info mb-3">
                          <div className="author-img mr-3">
                            <img
                              src="assets/img/client/2.jpg"
                              alt="client"
                              className="img-fluid"
                            />
                          </div>
                          <div className="media-body text-white">
                            <h5 className="mb-0 text-white">Arabella Ora</h5>
                            <span>HR Manager</span>
                          </div>
                          <i className="fas fa-quote-right text-white"></i>
                        </div>
                        <div className="client-say text-white">
                          <p>
                            Rapidiously develop user friendly growth strategies
                            after extensive initiatives. Conveniently grow
                            innovative benefits through fully tested
                            deliverables. Rapidiously utilize focused platforms
                            through end-to-end schemas.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <div className="testimonial-quote-wrap">
                        <div className="media author-info mb-3">
                          <div className="author-img mr-3">
                            <img
                              src="assets/img/client/3.jpg"
                              alt="client"
                              className="img-fluid"
                            />
                          </div>
                          <div className="media-body text-white">
                            <h5 className="mb-0 text-white">Jeremy Jere</h5>
                            <span>Team Leader</span>
                          </div>
                          <i className="fas fa-quote-right text-white"></i>
                        </div>
                        <div className="client-say text-white">
                          <p>
                            Objectively synthesize client-centered e-tailers for
                            maintainable channels. Holisticly administrate
                            customer directed vortals whereas tactical
                            functionalities. Energistically monetize reliable
                            imperatives through client-centric.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <div className="testimonial-quote-wrap">
                        <div className="media author-info mb-3">
                          <div className="author-img mr-3">
                            <img
                              src="assets/img/client/4.jpg"
                              alt="client"
                              className="img-fluid"
                            />
                          </div>
                          <div className="media-body text-white">
                            <h5 className="mb-0 text-white">John Charles</h5>
                            <span>Marketing Head</span>
                          </div>
                          <i className="fas fa-quote-right text-white"></i>
                        </div>
                        <div className="client-say text-white">
                          <p>
                            Enthusiastically innovate B2C data without
                            clicks-and-mortar convergence. Monotonectally
                            deliver compelling testing procedures vis-a-vis B2B
                            testing procedures. Competently evisculate
                            integrated resources whereas global.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="our-blog-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center">
                  <h2>Our Latest News</h2>
                  <p>
                    Efficiently matrix robust total linkage after market
                    positioning bandwidth. Holisticly restore B2B materials
                    rather than brand flexible paradigms vis-a-vis
                    mission-critical e-commerce.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <div className="single-blog-card card border-0 shadow-sm mt-4">
                  <div className="blog-img position-relative">
                    <img
                      src="assets/img/blog/1.jpg"
                      className="card-img-top"
                      alt="blog"
                    />
                    <div className="meta-date">
                      <strong>24</strong>
                      <small>Apr</small>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="post-meta mb-2">
                      <ul className="list-inline meta-list">
                        <li className="list-inline-item">
                          <i className="fas fa-heart mr-2"></i>
                          <span>45</span>
                          Comments
                        </li>
                        <li className="list-inline-item">
                          <i className="fas fa-share-alt mr-2"></i>
                          <span>10</span>
                          Share
                        </li>
                      </ul>
                    </div>
                    <h3 className="h5 mb-2 card-title">
                      <a href="#">Appropriately productize fully</a>
                    </h3>
                    <p className="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk.
                    </p>
                    <a href="#" className="detail-link">
                      Read more <span className="ti-arrow-right"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="single-blog-card card border-0 shadow-sm mt-4">
                  <div className="blog-img position-relative">
                    <img
                      src="assets/img/blog/2.jpg"
                      className="card-img-top"
                      alt="blog"
                    />
                    <div className="meta-date">
                      <strong>24</strong>
                      <small>Apr</small>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="post-meta mb-2">
                      <ul className="list-inline meta-list">
                        <li className="list-inline-item">
                          <i className="fas fa-heart mr-2"></i>
                          <span>45</span>
                          Comments
                        </li>
                        <li className="list-inline-item">
                          <i className="fas fa-share-alt mr-2"></i>
                          <span>10</span>
                          Share
                        </li>
                      </ul>
                    </div>
                    <h3 className="h5 mb-2 card-title">
                      <a href="#">Quickly formulate backend</a>
                    </h3>
                    <p className="card-text">
                      Synergistically engage effective ROI after customer
                      directed partnerships.
                    </p>
                    <a href="#" className="detail-link">
                      Read more <span className="ti-arrow-right"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="single-blog-card card border-0 shadow-sm mt-4">
                  <div className="blog-img position-relative">
                    <img
                      src="assets/img/blog/3.jpg"
                      className="card-img-top"
                      alt="blog"
                    />
                    <div className="meta-date">
                      <strong>24</strong>
                      <small>Apr</small>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="post-meta mb-2">
                      <ul className="list-inline meta-list">
                        <li className="list-inline-item">
                          <i className="fas fa-heart mr-2"></i>
                          <span>45</span>
                          Comments
                        </li>
                        <li className="list-inline-item">
                          <i className="fas fa-share-alt mr-2"></i>
                          <span>10</span>
                          Share
                        </li>
                      </ul>
                    </div>
                    <h3 className="h5 mb-2 card-title">
                      <a href="#">Objectively extend extensive</a>
                    </h3>
                    <p className="card-text">
                      Holisticly mesh open-source leadership rather than
                      proactive users.{" "}
                    </p>
                    <a href="#" className="detail-link">
                      Read more <span className="ti-arrow-right"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section id="contact" className="contact-us-section ptb-100">
          <div className="container">
            <div className="row justify-content-around">
              <div className="col-12 pb-3 message-box d-none">
                <div className="alert alert-danger"></div>
              </div>
              <div className="col-md-12 col-lg-5 mb-5 mb-md-5 mb-sm-5 mb-lg-0">
                <div className="contact-us-form gray-light-bg rounded p-5">
                  <h4>Ready to get started?</h4>
                  <form
                    action="#"
                    method="POST"
                    id="contactForm"
                    className="contact-us-form"
                  >
                    <div className="form-row">
                      <div className="col-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Enter name"
                            required="required"
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="Enter email"
                            required="required"
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            id="message"
                            className="form-control"
                            rows="7"
                            cols="25"
                            placeholder="Message"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-sm-12 mt-3">
                        <button
                          type="submit"
                          className="btn btn-brand-02"
                          id="btnContactUs"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-12 col-lg-6">
                <div className="contact-us-content">
                  <h2>Looking for a excellent Business idea?</h2>
                  <p className="lead">
                    Give us a call or drop by anytime, we endeavour to answer
                    all enquiries within 24 hours on business days.
                  </p>

                  <a
                    href="#"
                    className="btn btn-outline-brand-01 align-items-center"
                  >
                    Get Directions <span className="ti-arrow-right pl-2"></span>
                  </a>

                  <hr className="my-5" />

                  <ul className="contact-info-list">
                    <li className="d-flex pb-3">
                      <div className="contact-icon mr-3">
                        <span className="fas fa-location-arrow color-primary rounded-circle p-3"></span>
                      </div>
                      <div className="contact-text">
                        <h5 className="mb-1">Company Location</h5>
                        <p>100 Yellow House, Mn Factory, United State, 13420</p>
                      </div>
                    </li>
                    <li className="d-flex pb-3">
                      <div className="contact-icon mr-3">
                        <span className="fas fa-envelope color-primary rounded-circle p-3"></span>
                      </div>
                      <div className="contact-text">
                        <h5 className="mb-1">Email Address</h5>
                        <p>hello@yourdomain.com</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>

      <Newsletter />
      <Footer />
    </>
  );
}

export default WebBuilder;
